
import { TSX, Component, Prop, Vue } from 'vue-facing-decorator'
import { Action, State } from 'vuex-facing-decorator'

interface Props {
  pack: any
  order: any
}

/**
 * 必须用 TSX<Props>()(Vue) 而不是直接 extends Vue：
 * 是它把这个组件的 props 类型暴露给 TSX/JSX 的，
 * 少了它调用方写 <PackTrackDialog pack={...} /> 会报
 * 「Property 'pack' does not exist on type 'IntrinsicAttributes & {}'」
 */
@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({ type: Object, default: () => ({}) })
  pack: any

  @Prop({ type: Object, default: () => ({}) })
  order: any

  @State("express", {
    namespace: "store"
  })
  expressList

  @Action("store/getExpress")
  getExpress

  loading = false;
  /** 请求回来之前什么都不显示，免得先闪一下「暂无物流轨迹」 */
  load = false;
  source: any = {};

  /** 包裹上只存了 expressId，公司名要从快递公司列表里查 */
  get expressName() {
    let item = (this.expressList?.list || []).find((it) => it.id == this.pack.expressId);
    return item ? item.name : "-";
  }

  get expressBill() {
    return this.source.expressBill || this.pack.expressBill || "-";
  }

  get receiverName() {
    return this.pack.receiverName || this.order.name || "";
  }

  get receiverMobile() {
    return this.pack.receiverMobile || this.order.mobile || "";
  }

  /** 包裹上没存收货地址就退回订单上的 */
  get receiverAddress() {
    let packAddr = [this.pack.receiverProvince, this.pack.receiverCity, this.pack.receiverCounty, this.pack.receiverAddress]
      .filter(Boolean)
      .join("");
    if (packAddr) return packAddr;
    return [this.order.province, this.order.city, this.order.county, this.order.address].filter(Boolean).join("");
  }

  get trackList(): any[] {
    let s = this.source;
    if (Array.isArray(s)) return s;
    /**
     * 倒着排：接口给的是「最早的在前面」，而轨迹习惯最新的在最上面，
     * 上面那条高亮当前状态也依赖这个顺序
     */
    return (s.list || s.trackList || s.records || []).slice().reverse();
  }

  async created() {
    this.getExpress();
    this.loading = true;
    let { error, data } = await this.$post("/manager/order/view-pack-track", {
      id: this.pack.id,
    });
    this.loading = false;
    this.load = true;
    if (!error && data) {
      this.source = data;
    }
  }

  /** 轨迹字段名来自上游快递接口，各家写法不一样，挨个试 */
  trackTime(item) {
    for (let k of ["time", "createTime", "operateTime", "updateTime", "ftime"]) {
      if (item && item[k]) return this.$format(item[k], "YYYY-MM-DD HH:mm:ss");
    }
    return "";
  }

  trackContext(item) {
    for (let k of ["context", "content", "desc", "statusDesc", "remark"]) {
      if (item && item[k]) return item[k];
    }
    return "";
  }
}
